/*       */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Link from 'app/components/atoms/Link/Link';

const WorkspaceLink = props => {
    const { id, children, ...restProps } = props;
    return (
        <Link to={`/workspaces/${id}`} {...restProps}>
            {children}
        </Link>
    );
};

WorkspaceLink.propTypes = {
    id: PropTypes.string.isRequired,
};

export default memo(WorkspaceLink);
